import axios from "axios";

export const fetchUserDetails = async (isid: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_INTERNAL_DIRECTORY_BASE_URL}/users/${isid}`,
      {
        headers: {
          "x-merck-apikey": process.env.REACT_APP_INTERNAL_DIRECTORY_KEY,
        },
      },
    );
    return response.data;
  } catch (e) {
    return null;
  }
};
